export const API_ENDPOINTS = {
  ISPRODUCTION:{
    LOCAL: false,
    DEV: false,
    TEST: false,
    QA: false,
    E2E: false,
    STAGE: false,
    PROD: true
  },
  DESKING:{
    LOCAL: true,
    DEV: true,
    TEST: true,
    QA: true,
    E2E: true,
    STAGE: true,
    PROD: true,
  },
  HOSTNAME: {
    LOCAL: 'localhost',
    DEV: 'mstconsole.rti.dev.toyota.com',
    TEST: 'mstconsole.rti.test.toyota.com',
    QA: 'mstconsole.rti.qa.toyota.com',
    E2E: 'mstconsole.rti.e2e.toyota.com',
    STAGE: 'mstconsole.rti.stage.toyota.com',
    PROD: 'mstconsole.rti.toyota.com'
  },
  ENV: {
    LOCAL: 'development',
    DEV: 'development',
    TEST: 'test',
    QA: 'qa',
    E2E: 'e2e',
    STAGE: 'stage',
    PROD: 'production'
  },
  STORE_DEV_TOOLS: {
    LOCAL: 'monitor',
    DEV: 'monitor',
    TEST: 'monitor',
    QA: 'monitor',
    E2E: 'monitor',
    STAGE: 'monitor',
    PROD: 'monitor'
  },
  MIN_LOG_LEVEL: {
    LOCAL: 'ERROR',
    DEV: 'ERROR',
    TEST: 'ERROR',
    QA: 'ERROR',
    E2E: 'ERROR',
    STAGE: 'ERROR',
    PROD: 'ERROR'
  },
  ACTUAL_ENV: {
    LOCAL: 'local',
    DEV: 'development',
    TEST: 'test',
    QA: 'qa',
    E2E: 'e2e',
    STAGE: 'stage',
    PROD: 'production'
  }, //  PROD ? JSON.stringify('production') : QA ? JSON.stringify('qa') : TEST ? JSON.stringify('test') : E2E ? JSON.stringify('e2e') : STAGE ? JSON.stringify('stage') : JSON.stringify('development'),
  EFC_URL: {
    LOCAL: 'https://media.rti.dev.toyota.com/config/services/fm/seriesData',
    DEV: 'https://media.rti.dev.toyota.com/config/services/fm/seriesData',
    TEST: 'https://media.rti.dev.toyota.com/config/services/fm/seriesData',
    QA: 'https://media.rti.dev.toyota.com/config/services/fm/seriesData',
    E2E: 'https://media.rti.dev.toyota.com/config/services/fm/seriesData',
    STAGE: 'https://media.rti.stage.toyota.com/config/services/fm/seriesData',
    PROD: 'https://media.rti.toyota.com/config/services/fm/seriesData'
  },
  AUTH_BASE_URL: {
    LOCAL: 'http://localhost:3004',
    DEV: 'https://mstconsole.rti.dev.toyota.com',
    TEST: 'https://mstconsole.rti.test.toyota.com',
    QA: 'https://mstconsole.rti.qa.toyota.com',
    E2E: 'https://mstconsole.rti.qa.toyota.com',
    STAGE: 'https://mstconsole.rti.stage.toyota.com',
    PROD: 'https://mstconsole.rti.toyota.com',
  },
  DIS_URL: {
    LOCAL: 'https://eigws.toyota.com/Dealer/DISRestService/rest/',
    DEV: 'https://eigws.toyota.com/Dealer/DISRestService/rest/',
    TEST: 'https://eigws.toyota.com/Dealer/DISRestService/rest/',
    QA: 'https://eigws.toyota.com/Dealer/DISRestService/rest/',
    E2E: 'https://eigws.toyota.com/Dealer/DISRestService/rest/',
    STAGE: 'https://eigws.toyota.com/Dealer/DISRestService/rest/',
    PROD: 'https://eigws.toyota.com/Dealer/DISRestService/rest/',
  },
  BASE_SERVICE_URL: {
    LOCAL: 'https://api.rti.stage.toyota.com',
    DEV: 'https://api.rti.qa.toyota.com',
    TEST: 'https://api.rti.qa.toyota.com',
    QA: 'https://api.rti.qa.toyota.com',
    E2E: 'https://api.rti.e2e.toyota.com',
    STAGE: 'https://api.rti.stage.toyota.com',
    PROD: 'https://api-ro.rti.toyota.com',
  },
   PRESOLD_BASE_SERVICE_URL: {
    LOCAL: 'https://api.rti.qa.toyota.com',
    DEV: 'https://api.rti.qa.toyota.com',
    TEST: 'https://api.rti.qa.toyota.com',
    QA: 'https://api.rti.qa.toyota.com',
    E2E: 'https://api.rti.e2e.toyota.com',
    STAGE: 'https://api.rti.stage.toyota.com',
    PROD: 'https://api.rti.toyota.com',
  },
   USED_VEHICLE_BASE_SERVICE_URL: {
    LOCAL: 'https://dxiu-api.qa.dealer.toyota.com',
    DEV: 'https://dxiu-api.qa.dealer.toyota.com',
    TEST: 'https://dxiu-api.qa.dealer.toyota.com',
    QA: 'https://dxiu-api.qa.dealer.toyota.com',
    E2E: 'https://dxiu-api.qa.dealer.toyota.com',
    STAGE: 'https://dxiu-api.qa.dealer.toyota.com',
    PROD: 'https://dxiu-api.dealer.toyota.com',
  },
  POST_LOGOUT_REDIRECT_URL:
  {
    LOCAL: 'https://cpssologin-dc2.stg.toyota.com/tesslogin/logout.jsp?end_url=https://dealerdailyfr.qa.toyota.com',
    DEV: 'https://cpssologin-dc2.stg.toyota.com/tesslogin/logout.jsp?end_url=https://dealerdailyfr.qa.toyota.com',
    TEST: 'https://cpssologin-dc2.stg.toyota.com/tesslogin/logout.jsp?end_url=https://dealerdailyfr.qa.toyota.com',
    QA: 'https://cpssologin-dc2.stg.toyota.com/tesslogin/logout.jsp?end_url=https://dealerdailyfr.qa.toyota.com',
    E2E: 'https://cpssologin-dc2.stg.toyota.com/tesslogin/logout.jsp?end_url=https://dealerdailyfr.qa.toyota.com',
    STAGE: 'https://cpssologin-dc2.stg.toyota.com/tesslogin/logout.jsp?end_url=https://dealerdailyfr.qa.toyota.com',
    PROD: 'https://cpssologin-dc2.toyota.com/tesslogin/logout.jsp?end_url=https://dealerdaily.toyota.com',
  },
  SILENT_REDIRECT_URL: {
    LOCAL: 'http://localhost:3004',
    DEV: 'https://mstconsole.rti.dev.toyota.com',
    TEST: 'https://mstconsole.rti.test.toyota.com',
    QA: 'https://mstconsole.rti.qa.toyota.com',
    E2E: 'https://mstconsole.rti.qa.toyota.com',
    STAGE: 'https://mstconsole.rti.stage.toyota.com',
    PROD: 'https://mstconsole.rti.toyota.com'

  },
  AUTHORIZATION_ENDPOINT: {
    LOCAL: 'https://login.microsoftonline.com/tmnab2cqa.onmicrosoft.com/oauth2/v2.0/authorize?p=B2C_1A_RT_Toyota_QA_SignInPolicy',
    DEV: 'https://login.microsoftonline.com/tmnab2cqa.onmicrosoft.com/oauth2/v2.0/authorize?p=B2C_1A_RT_Toyota_DEV_SignInPolicy',
    TEST: 'https://login.microsoftonline.com/tmnab2cqa.onmicrosoft.com/oauth2/v2.0/authorize?p=B2C_1A_RT_Toyota_DEV_SignInPolicy',
    QA: 'https://login.microsoftonline.com/tmnab2cqa.onmicrosoft.com/oauth2/v2.0/authorize?p=B2C_1A_RT_Toyota_QA_SignInPolicy',
    E2E: 'https://login.microsoftonline.com/tmnab2cqa.onmicrosoft.com/oauth2/v2.0/authorize?p=B2C_1A_RT_Toyota_QA_SignInPolicy',
    STAGE: 'https://login.microsoftonline.com/tmnab2cqa.onmicrosoft.com/oauth2/v2.0/authorize?p=B2C_1A_RT_Toyota_QA_SignInPolicy',
    PROD: 'https://login.microsoftonline.com/tmnab2c.onmicrosoft.com/oauth2/v2.0/authorize?p=B2C_1A_RT_Toyota_Prod_SignInPolicy',

  },
  ISSUER: {
    LOCAL: 'https://login.microsoftonline.com/f855c7e1-6646-4300-8de1-10c7d3001287/v2.0/',
    DEV: 'https://login.microsoftonline.com/f855c7e1-6646-4300-8de1-10c7d3001287/v2.0/',
    TEST: 'https://login.microsoftonline.com/f855c7e1-6646-4300-8de1-10c7d3001287/v2.0/',
    QA: 'https://login.microsoftonline.com/f855c7e1-6646-4300-8de1-10c7d3001287/v2.0/',
    E2E: 'https://login.microsoftonline.com/f855c7e1-6646-4300-8de1-10c7d3001287/v2.0/',
    STAGE: 'https://login.microsoftonline.com/f855c7e1-6646-4300-8de1-10c7d3001287/v2.0/',
    PROD: 'https://login.microsoftonline.com/367ee18c-355b-47e1-aa4e-7ff91783caf5/v2.0/',
  },
  JWTURI: {
    LOCAL: 'https://login.microsoftonline.com/tmnab2cqa.onmicrosoft.com/discovery/v2.0/keys?p=B2C_1A_RT_Toyota_QA_SignInPolicy',
    DEV: 'https://login.microsoftonline.com/tmnab2cqa.onmicrosoft.com/discovery/v2.0/keys?p=B2C_1A_RT_Toyota_DEV_SignInPolicy',
    TEST: 'https://login.microsoftonline.com/tmnab2cqa.onmicrosoft.com/discovery/v2.0/keys?p=B2C_1A_RT_Toyota_DEV_SignInPolicy',
    QA: 'https://login.microsoftonline.com/tmnab2cqa.onmicrosoft.com/discovery/v2.0/keys?p=B2C_1A_RT_Toyota_QA_SignInPolicy',
    E2E: 'https://login.microsoftonline.com/tmnab2cqa.onmicrosoft.com/discovery/v2.0/keys?p=B2C_1A_RT_Toyota_QA_SignInPolicy',
    STAGE: 'https://login.microsoftonline.com/tmnab2cqa.onmicrosoft.com/discovery/v2.0/keys?p=B2C_1A_RT_Toyota_QA_SignInPolicy',
    PROD: 'https://login.microsoftonline.com/tmnab2c.onmicrosoft.com/discovery/v2.0/keys?p=B2C_1A_RT_Toyota_Prod_SignInPolicy'
  },

  AUTHORITY: {
    LOCAL: 'https://login.microsoftonline.com/tmnab2cqa.onmicrosoft.com/v2.0/',
    DEV: 'https://login.microsoftonline.com/tmnab2cqa.onmicrosoft.com/v2.0/',
    TEST: 'https://login.microsoftonline.com/tmnab2cqa.onmicrosoft.com/v2.0/',
    QA: 'https://login.microsoftonline.com/tmnab2cqa.onmicrosoft.com/v2.0/',
    E2E: 'https://login.microsoftonline.com/tmnab2cqa.onmicrosoft.com/v2.0/',
    STAGE: 'https://login.microsoftonline.com/tmnab2cqa.onmicrosoft.com/v2.0/',
    PROD: 'https://login.microsoftonline.com/tmnab2c.onmicrosoft.com/v2.0/'
  },
  CLIENT_ID: {
    LOCAL: 'd241ff91-a0e9-422e-b3e0-7abdf86600f3',
    DEV: '662997f7-0772-45d4-ba49-a1bd6d2e60a2',
    TEST: '662997f7-0772-45d4-ba49-a1bd6d2e60a2',
    QA: 'd241ff91-a0e9-422e-b3e0-7abdf86600f3',
    E2E: 'd241ff91-a0e9-422e-b3e0-7abdf86600f3',
    STAGE: '1fe9daf2-1366-4738-a89d-da29b80be2bc',
    PROD: '09477438-b312-483c-92cd-f5e991ce2447'
  },
  CONSUMER_PREVIEW_ENDPOINT: {
    LOCAL: 'https://cdn.rticint.deops.toyota.com/static/rti/latest/static/pages/preview.html?env=dev&vin=',
    DEV: 'https://cdn.rticint.deops.toyota.com/static/rti/latest/static/pages/preview.html?env=dev&vin=',
    TEST: 'https://cdn.rticint.deops.toyota.com/static/rti/latest/static/pages/preview.html?env=dev&vin=',
    QA: 'https://cdn.rticint.deops.toyota.com/static/rti/latest/static/pages/preview.html?env=dev&vin=',
    E2E: 'https://cdn.rticint.deops.toyota.com/static/rti/latest/static/pages/preview.html?env=dev&vin=',
    STAGE: 'https://cdn.rticint.deops.toyota.com/static/rti/latest/static/pages/preview.html?env=int&vin=',
    PROD: 'https://cdn.rtic.toyota.com/static/rti/latest/static/pages/preview.html?env=prod&vin='
  },
  MST_BASE_SERVICE_URL: {
    LOCAL: 'https://mobile-api.rti.stage.toyota.com/',
    DEV: 'https://mobile-api.rti.qa.toyota.com/',
    TEST: 'https://mobile-api.rti.test.toyota.com/',
    QA: 'https://mobile-api.rti.qa.toyota.com/',
    E2E: 'https://mobile-api.rti.qa.toyota.com/',
    STAGE: 'https://mobile-api.rti.stage.toyota.com/',
    PROD: 'https://mobile-api.rti.toyota.com/'

  },
  DG_BASE_SERVICE_URL: {
    LOCAL: 'https://api.stage.dg.toyota.com/',
    DEV: 'https://api.stage.dg.toyota.com/',
    TEST: 'https://api.stage.dg.toyota.com/',
    QA: 'https://api.stage.dg.toyota.com/',
    E2E: 'https://api.stage.dg.toyota.com/',
    STAGE: 'https://api.demo.dg.toyota.com/',
    PROD: 'https://api.dg.toyota.com/'
  },
  SOCKET_ENDPOINT: {
    LOCAL: 'wss://websocket-api.rti.qa.toyota.com?appName=CON&userType=SalesManager&Authorization=',
    DEV: 'wss://websocket-api.rti.dev.toyota.com?appName=CON&userType=SalesManager&Authorization=',
    TEST: 'wss://websocket-api.rti.test.toyota.com?appName=CON&userType=SalesManager&Authorization=',
    QA: 'wss://websocket-api.rti.qa.toyota.com?appName=CON&userType=SalesManager&Authorization=',
    E2E: 'wss://websocket-api.rti.qa.toyota.com?appName=CON&userType=SalesManager&Authorization=',
    STAGE: 'wss://websocket-api.rti.stage.toyota.com?appName=CON&userType=SalesManager&Authorization=',
    PROD: 'wss://websocket-api.rti.toyota.com?appName=CON&userType=SalesManager&Authorization=',
  },
  VSPEC_GUEST_PORTAL: {
    LOCAL: 'https://guest.smartpath.test.toyota.com/',
    DEV: 'https://guest.smartpath.test.toyota.com/',
    TEST: 'https://guest.smartpath.test.toyota.com/',
    QA: 'https://guest.smartpath.test.toyota.com/',
    E2E: 'https://guest.smartpath.test.toyota.com/',
    STAGE: 'https://guest.smartpath.stage.toyota.com/',
    PROD: 'https://guest.smartpath.toyota.com/',

  },
  CREDIT_APP_URL: {
    LOCAL: 'https://apigateway-stage.toyotafinancial.com/ocainboundservices/oca/services/prefilldata',
    DEV: 'https://apigateway-stage.toyotafinancial.com/ocainboundservices/oca/services/prefilldata',
    TEST: 'https://apigateway-stage.toyotafinancial.com/ocainboundservices/oca/services/prefilldata',
    QA: 'https://apigateway-stage.toyotafinancial.com/ocainboundservices/oca/services/prefilldata',
    E2E: 'https://apigateway-stage.toyotafinancial.com/ocainboundservices/oca/services/prefilldata',
    STAGE: 'https://apigateway-stage.toyotafinancial.com/ocainboundservices/oca/services/prefilldata',
    PROD: 'https://apigateway.toyotafinancial.com/ocainboundservices/oca/services/prefilldata'
  },
  ENGAGE_MATERIAL_URL:{
    LOCAL: 'https://staging.engage.toyota.com/smartPath/training?tab=Management_Console',
		DEV: 'https://staging.engage.toyota.com/smartPath/training?tab=Management_Console',
    TEST: 'https://staging.engage.toyota.com/smartPath/training?tab=Management_Console',
    E2E: 'https://staging.engage.toyota.com/smartPath/training?tab=Management_Console',
		QA: 'https://staging.engage.toyota.com/smartPath/training?tab=Management_Console',
		STAGE: 'https://staging.engage.toyota.com/smartPath/training?tab=Management_Console',
	  PROD: 'https://engage.toyota.com/smartPath/training?tab=Management_Console',
  },
  ENGAGE_MATERIAL_LEXUS_URL:{
    LOCAL: 'https://www.lexuslearn.com/retailinnovation',
    DEV: 'https://www.lexuslearn.com/retailinnovation',
    TEST: 'https://www.lexuslearn.com/retailinnovation',
    QA: 'https://www.lexuslearn.com/retailinnovation',
    E2E: 'https://www.lexuslearn.com/retailinnovation',
    STAGE: 'https://www.lexuslearn.com/retailinnovation',
    PROD: 'https://www.lexuslearn.com/retailinnovation'
  },
  MST_CONSOLE:{
    LOCAL: 'MSTConsole',
    DEV: 'MSTConsole',
    TEST: 'MSTConsole',
    QA: 'MSTConsole',
    E2E: 'MSTConsole',
    STAGE: 'MSTConsole',
    PROD: 'MSTConsole'
  },
  AUTH_AUTHORITY:{
    LOCAL: 'https://ep.fram.qa.idm.toyota.com/openam/oauth2/realms/root/realms/dealerdaily/.well-known/openid-configuration',
    DEV: 'https://ep.fram.qa.idm.toyota.com/openam/oauth2/realms/root/realms/dealerdaily/.well-known/openid-configuration',
    TEST: 'https://ep.fram.qa.idm.toyota.com/openam/oauth2/realms/root/realms/dealerdaily/.well-known/openid-configuration',
    QA: 'https://ep.fram.qa.idm.toyota.com/openam/oauth2/realms/root/realms/dealerdaily/.well-known/openid-configuration',
    E2E: 'https://ep.fram.qa.idm.toyota.com/openam/oauth2/realms/root/realms/dealerdaily/.well-known/openid-configuration',
    STAGE: 'https://ep.fram.qa.idm.toyota.com/openam/oauth2/realms/root/realms/dealerdaily/.well-known/openid-configuration',
    PROD: 'https://ep.fram.idm.toyota.com/openam/oauth2/realms/root/realms/dealerdaily/.well-known/openid-configuration'
  },
  SIGNAL: {
    LOCAL: 'https://qa.dealer.toyota.com/signal/customer',
    DEV: 'https://qa.dealer.toyota.com/signal/customer',
    TEST: 'https://qa.dealer.toyota.com/signal/customer',
    QA: 'https://qa.dealer.toyota.com/signal/customer',
    E2E: 'https://qa.dealer.toyota.com/signal/customer',
    STAGE: 'https://stage.dealer.toyota.com/signal/customer',
    PROD: 'https://dealer.toyota.com/signal/customer'
  },
  TRADE_SIGNAL_ENDPOINT: {
    LOCAL: 'https://signal-api.qa.dealer.toyota.com',
    DEV: 'https://signal-api.qa.dealer.toyota.com',
    TEST: 'https://signal-api.test.dealer.toyota.com',
    QA: 'https://signal-api.qa.dealer.toyota.com',
    E2E: 'https://signal-api.qa.dealer.toyota.com',
    STAGE: 'https://signal-api.stage.dealer.toyota.com',
    PROD: 'https://signal-api.dealer.toyota.com'
  }
};